import React, { FC } from "react";

import { Link, Stack, Typography } from "@mui/material";

type Items = {
  label: string;
  href: string;
}[];

const items: Items = [
  {
    label: "About us",
    href: "https://www.pomerium.com",
  },
  {
    label: "Docs",
    href: "https://www.pomerium.com/docs/",
  },
  {
    label: "Support",
    href: "mailto:support@pomerium.com",
  },
];

export const Footer: FC = () => (
  <Stack direction="row" justifyContent="center" sx={{ mt: 1, mb: 2, mx: 2 }}>
    <Stack alignContent="center">
      <Stack direction="row" spacing={2}>
        {items.map((link) => (
          <Link
            color="primary"
            href={link.href}
            key={link.label}
            target="_blank"
            underline="none"
            variant="body2"
          >
            {link.label}
          </Link>
        ))}
      </Stack>
      <Typography color="textPrimary" variant="caption" sx={{ pl: 5 }}>
        © {new Date().getFullYear()} Pomerium
      </Typography>
    </Stack>
  </Stack>
);
